import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ACTION_TONE = {
  "auth.login": "bg-blue-50 text-blue-700 border-blue-200",
  "customer.create": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "application.create": "bg-orange-50 text-orange-700 border-orange-200",
  "application.pay": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "staff.create": "bg-purple-50 text-purple-700 border-purple-200",
  "staff.update": "bg-slate-100 text-slate-700 border-slate-200",
  "staff.delete": "bg-red-50 text-red-700 border-red-200",
};

export default function AuditLogs() {
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div className="p-8 max-w-[1400px]">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-orange-600 font-semibold mb-2">Compliance</div>
        <h1 className="text-4xl font-bold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>Audit Logs</h1>
        <p className="text-sm text-slate-600 mt-2">Every action worth remembering — logins, applications, payments and staff changes.</p>
      </div>

      <Card className="bg-white border-slate-200 overflow-hidden" data-testid="audit-table">
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead className="text-xs uppercase tracking-[0.15em] text-slate-500">When</TableHead>
              <TableHead className="text-xs uppercase tracking-[0.15em] text-slate-500">User</TableHead>
              <TableHead className="text-xs uppercase tracking-[0.15em] text-slate-500">Action</TableHead>
              <TableHead className="text-xs uppercase tracking-[0.15em] text-slate-500">Target</TableHead>
              <TableHead className="text-xs uppercase tracking-[0.15em] text-slate-500">Details</TableHead>
              <TableHead className="text-xs uppercase tracking-[0.15em] text-slate-500">IP</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-16">No activity yet.</TableCell></TableRow>}
            {rows.map((r) => (
              <TableRow key={r.id} className="hover:bg-slate-50">
                <TableCell className="text-xs font-mono text-slate-600">{new Date(r.at).toLocaleString()}</TableCell>
                <TableCell>
                  <div className="font-medium text-sm">{r.user_name || r.user_email || "—"}</div>
                  <div className="text-[10px] text-slate-500 uppercase tracking-wider">{r.user_role}</div>
                </TableCell>
                <TableCell><Badge variant="outline" className={`${ACTION_TONE[r.action] || ""} font-mono text-[10px]`}>{r.action}</Badge></TableCell>
                <TableCell className="text-xs">{r.target_type}<br /><span className="font-mono text-slate-500">{r.target_id?.slice(-8)}</span></TableCell>
                <TableCell className="text-xs text-slate-600 max-w-xs truncate">{Object.keys(r.meta || {}).length > 0 ? JSON.stringify(r.meta) : "—"}</TableCell>
                <TableCell className="text-xs font-mono text-slate-500">{r.ip || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
